/**
 * @generated SignedSource<<b5c60121e6fbd46cd0d52abd81cf148d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { DateTime } from "@/common/relayCustomScalar";
import { Semver } from "@/common/relayCustomScalar";
export type WorkspaceVersionPublishButtonMutation$variables = {
  id: string;
};
export type WorkspaceVersionPublishButtonMutation$data = {
  readonly publishWorkspaceVersion: {
    readonly id: string;
    readonly latest: boolean;
    readonly publishedAt: DateTime | null | undefined;
    readonly workspace: {
      readonly id: string;
      readonly latestVersion: {
        readonly id: string;
        readonly version: Semver;
      } | null | undefined;
    };
  };
};
export type WorkspaceVersionPublishButtonMutation = {
  response: WorkspaceVersionPublishButtonMutation$data;
  variables: WorkspaceVersionPublishButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "WorkspaceVersion",
    "kind": "LinkedField",
    "name": "publishWorkspaceVersion",
    "plural": false,
    "selections": [
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "latest",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "publishedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkspaceVersion",
            "kind": "LinkedField",
            "name": "latestVersion",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "version",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceVersionPublishButtonMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "WorkspaceVersionPublishButtonMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "70d5a2df26b2a7e0fce06893d018617d",
    "id": null,
    "metadata": {},
    "name": "WorkspaceVersionPublishButtonMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceVersionPublishButtonMutation(\n  $id: ID!\n) {\n  publishWorkspaceVersion(id: $id) {\n    id\n    latest\n    publishedAt\n    workspace {\n      id\n      latestVersion {\n        id\n        version\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "24ea488f0b19f4b196d7008ce978c3f8";

export default node;
